












































import {Component, Vue} from 'vue-property-decorator';

import {userStore} from '@/store/store';
import ErrorDisplay from '@/views/components/projects/ErrorDisplay.vue';
import {email, required} from 'vuelidate/lib/validators';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import {$http} from '@/main';


// Component.registerHooks(['esalMethodValidations']);

@Component({
  components: {PxTextEntryBox, PxTextArea, ErrorDisplay},
  validations: {
    loginEmail: {
      required,
      email,
    },
    loginPassword: {
      required,
    },
  },
})
export default class LoginModal extends Vue {
  loginEmail = '';

  loginPassword = '';

  lastLoginFailed = false;

  failureMessage = '';


  get errors() {
    return userStore.httpErrors;
  }

  mounted() {
    userStore.clearErrors();
  }

  submitLogin(): void {
    console.log('Logging in');

    userStore.login({email: this.loginEmail, password: this.loginPassword}).then((result) => {
      if (result) {
        this.$root.$emit('bv::hide::modal', 'login-modal');
        // this.$router.push("/projects");

        // if (userStore.userIsLoggedIn){
        //   projectStore.checkForLegacyReports(userStore.user);
        // }
        // projectStore.loadAvailableProjects();
        this.$router.push('/projects');
      }

      // projectStore.loadAvailableReportsLegacy(userStore.user)
    });
  }

  resetMessage: string | null = null;

  resetPassword() {
    $http.post('/password_reset/', {email: this.loginEmail})
        .then(() => {
          this.resetMessage = `An email containing password reset information has been sent to ${this.loginEmail}`;
        })
        .catch((reason) => userStore.pushHttpErrors(reason));
  }
}
